export const formatProcessingCharge = (rate: string, fixed: string): string => {
    const rateLabel = formatRate(rate);
    const fixedLabel = formatFixed(fixed);

    if (!fixedLabel) {
        return rateLabel;
    }

    return `${rateLabel} + ${fixedLabel}`;
};

const formatRate = (rate: string): string => {
    const value = Number(rate);

    if (!Number.isFinite(value)) {
        return rate ? `${rate}%` : '';
    }

    return `${value.toFixed(1)}%`;
};

const formatFixed = (fixed: string): string | null => {
    const value = Number(fixed);

    if (!Number.isFinite(value) || value === 0) {
        return null;
    }

    return `$${value.toFixed(2)}`;
};
